import dynamic from 'next/dynamic';

import React, { useState } from "react";
import { Collapse } from "react-collapse";
import Link from "next/link";
import Image from "next/image";
const Icon = dynamic(() => import('@/components/ui/Icon'), { ssr: false });
import Multilevel from "./Multi";

const Submenu = ({ activeSubmenu, item, i, locationName }) => {
  const [activeMultiMenu, setMultiMenu] = useState(null);
  const normalizePath = (p) => (p || "").split("?")[0].split("#")[0].replace(/^\/+/, "");
  
  const toggleMultiMenu = (j) => {
    if (activeMultiMenu === j) {
      setMultiMenu(null);
    } else {
      setMultiMenu(j);
    }
  };

  return (
    <Collapse isOpened={activeSubmenu === i}>
      <ul className="sub-menu  space-y-4  ">
        {item.child?.map((subItem, j) => (
          <li key={j} className="block pl-4 pr-1 first:pt-4  last:pb-4">
            {subItem?.multi_menu ? (
              <div>
                <div
                  onClick={() => toggleMultiMenu(j)}
                  className={`${
                    activeMultiMenu
                      ? " text-black dark:text-white font-medium"
                      : "text-zinc-600 dark:text-zinc-300"
                  } text-sm flex space-x-3 items-center transition-all duration-150 cursor-pointer`}
                >
                  <span
                    className={`${
                      activeMultiMenu
                        ? " bg-metaxseed-black dark:bg-zinc-300 ring-4 ring-opacity-[15%] ring-black-500 dark:ring-slate-300 dark:ring-opacity-20"
                        : ""
                    } h-2 w-2 rounded-full border border-slate-600 dark:border-white inline-block flex-none `}
                  ></span>
                  <span className="flex-1">{subItem.childtitle}</span>
                  <span className="flex-none">
                    <span
                      className={`menu-arrow transform transition-all duration-300 ${
                        activeMultiMenu === j ? " rotate-90" : ""
                      }`}
                    >
                      <Icon icon="ph:caret-right" />
                    </span>
                  </span>
                </div>
                <Multilevel
                  activeMultiMenu={activeMultiMenu}
                  j={j}
                  subItem={subItem}
                  locationName={locationName}
                />
              </div>
            ) : subItem.isExternal ? (
              <a
                href={subItem.childlink}
                target="_blank"
                rel="noopener noreferrer"
                className={`${
                  locationName === normalizePath(subItem.childlink) || locationName.startsWith(normalizePath(subItem.childlink) + "/")
                    ? " text-black dark:text-white font-medium active"
                    : "text-zinc-600 dark:text-zinc-300"
                } w-full px-2 py-2 rounded-md text-sm flex space-x-3 items-center transition-all duration-150 hover:!text-white hover:bg-white/5 group`}
              >
                {subItem.childicon && (
                  <span className="flex-grow-0 text-base inline-flex items-center ltr:mr-1 rtl:ml-1">
                    {subItem.childicon.startsWith('/') || subItem.childicon.startsWith('http') ? (
                      <Image 
                        src={subItem.childicon} 
                        alt={subItem.childtitle} 
                        width={20} 
                        height={20} 
                        className="w-5 h-5 transition-all duration-150 group-hover:brightness-0 group-hover:invert"
                      />
                    ) : (
                      <Icon icon={subItem.childicon} />
                    )}
                  </span>
                )}
                <div className="text-box text-left text-sm py-1 px-1 inline-flex">{subItem.childtitle}</div>
              </a>
            ) : (
              <Link
                href={subItem.childlink}
                className={`${
                  locationName === normalizePath(subItem.childlink) || locationName.startsWith(normalizePath(subItem.childlink) + "/")
                    ? " text-black dark:text-white font-medium active"
                    : "text-zinc-600 dark:text-zinc-300"
                } w-full px-2 py-2 rounded-md text-sm flex space-x-3 items-center transition-all duration-150 hover:!text-white hover:bg-white/5 group`}
              >
                {subItem.childicon && (
                  <span className="flex-grow-0 text-base inline-flex items-center ltr:mr-1 rtl:ml-1">
                    {subItem.childicon.startsWith('/') || subItem.childicon.startsWith('http') ? (
                      <Image 
                        src={subItem.childicon} 
                        alt={subItem.childtitle} 
                        width={20} 
                        height={20} 
                        className="w-5 h-5 transition-all duration-150 group-hover:brightness-0 group-hover:invert"
                      />
                    ) : (
                      <Icon icon={subItem.childicon} />
                    )}
                  </span>
                )}
                <div className="text-box text-left text-sm py-1 px-1 inline-flex">{subItem.childtitle}</div>
              </Link>
            )}
          </li>
        ))}
      </ul>
    </Collapse>
  );
};

export default Submenu;

